import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full h-20 rounded-md mx-auto"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-row items-start h-full justify-start p-3 space-x-5\"><div class=\"w-10 bg-gray-300 h-10 rounded-full\"></div><div class=\"flex flex-col space-y-3 w-full\"><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-1/2 bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "w-full rounded-md mx-auto"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex animate-pulse flex-row items-start justify-start py-3 space-x-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col space-y-3 w-full" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "w-full bg-gray-300 h-6 rounded-md" })
  ])
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 2,
  class: "w-full h-20 rounded-md mx-auto mt-20"
}
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-row items-center h-full justify-start p-3 space-x-5\"><div class=\"w-10 bg-gray-300 h-10 rounded-full\"></div><div class=\"flex flex-col space-y-3 w-full\"><div class=\"w-2/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-1/2 bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = {
  key: 3,
  class: "w-full h-20 rounded-md mx-auto mt-8"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex animate-pulse flex-row items-center h-full justify-start p-3 space-x-5\"><div class=\"flex flex-col space-y-2 w-full\"><div class=\"w-1/3 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-1/2 bg-gray-300 h-6 rounded-md\"></div><div class=\"w-full bg-gray-300 h-6 rounded-md\"></div></div></div>", 1)
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.option === 'candidates')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    (_ctx.option === 'text')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.option === 'card')
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      : _createCommentVNode("", true),
    (_ctx.option === 'card-meeting')
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true)
  ], 64))
}